import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Disable browser scroll restoration (important for Safari/iOS)
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    // Reset scroll (cross-browser safe)
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // avoid smooth glitches on some browsers
    });

    // Fallback for older browsers
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

  }, [pathname]);

  return null;
};

export default ScrollToTop;